import { z } from 'zod';

export const RefreshTokenScalarFieldEnumSchema = z.enum(['id','refresh_token','user_id','data','microsoft_data','created_at','updated_at','expired_at','last_access_token_created_at']);

export default RefreshTokenScalarFieldEnumSchema;
